import React, { Component } from "react";
import { Breadcrumb, Button, Tabs, Badge, Steps } from "antd";
import { Link, withRouter } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import {
  FaBuilding,
  FaCheck,
  FaFile,
  FaFileAlt,
  FaFileInvoice,
  FaFileInvoiceDollar,
  FaFileSignature,
  FaMoneyCheck,
  FaUserAlt,
  FaInfo
} from "react-icons/fa";
import "./Client.scss";
import ClientInfo from "../../components/ClientInfo/ClientInfo";
import ClientOrder from "../../components/ClientOrder/ClientOrder";
import ClientProperty from "../../components/ClientProperty/ClientProperty";
import Debtsdata from "../../components/Debtsdata/Debtsdata";
import Calculation from "../../components/Calculation/Calculation";
import ClientDocs from "../../components/ClientDocs/ClientDocs";
import ClientNotes from "../../components/ClientNotes/ClientNotes";
import ClientBonds from "../../components/ClientBonds/ClientBonds"; 
import { exportContractToPdf } from "../../components/PdfGenerator/Pdf.helper";
import { connect } from "react-redux";
import { GetAllComments, GetFinancingRequestDetails } from "../../network/request.network";
import moment from "moment-hijri";
import ClientStatues from "../../components/ClientStatues/ClientStatues";
const { TabPane } = Tabs; 
const { Step } = Steps;

class Client extends Component {

  state = {
    activeTab : "1",
    docCompelted: false,
    current: -1,
    activeStatuse : null,
    orderData : null,
    loading: false,
    commentCount:0
  }


  componentDidMount() {
    const { match: { params } } = this.props;
    this.setState({loading : true})
    params.tab ? this.setState({ activeTab: params.tab }) : this.setState({ activeTab: '1' })
    let orderId = this.props.location?.state.orderId;

    GetFinancingRequestDetails(
      orderId,
      (res)=>{
        this.setState({
          orderData:res.data?.model, 
          loading: false,
          activeStatuse : res.data?.model?.FinanceRequestStatusId 
        }); 
      },
      (err)=>{
        this.setState({loading : false})
      })
      this.updateNotesBadge(orderId);
  }

  updateNotesBadge=(id)=>{
    let body={
      Id:id,
      Page:0
    }
    GetAllComments( 
      body,
      (res)=>{
        this.setState({commentCount:res.data.model.filter(comm => comm.AspNetUsers?.UserTypeId === 1).length}) 
      },
      ()=>{}
    )
  }

  handelChangeTabs = (val) => {
    this.setState({activeTab : val})
  }

  render() {
    const { docCompelted, current, activeStatuse, orderData, loading  } = this.state;
    let orderId = this.props.location?.state.orderId;

    return (
      <div className="client-info-page">
        <div className="header-img-holder">
          <div className="container">
            <div className="client-header">
              <div className="client-header-first">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <Link to="/">
                      <HomeOutlined />
                      <p className="link-name">الرئيسية</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/orders">
                      <p className="link-name">الطلبات</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="last-bread">
                    عرض الطلب
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1>{orderData?.Id}</h1>
              </div>

              {/* see the order steps */}
              <div className="finance-header-sec">
                <div className="steps-header">
                <Steps size="small" labelPlacement="vertical" current={current}>              
                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 1) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 1)
                   ? <FaCheck/> : false} title=" تم استلام الطلب"/>

                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 4) 
                  ? "step-complate" : "step-failed"} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 4)
                   ? <FaCheck/> : <FaInfo />} title=" اكمال المستندات"/>
                  
                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 7) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 7)
                   ? <FaCheck/> : false} title=" اعتماد الحسبة"/>
                  
                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 15) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 15)
                   ? <FaCheck/> : false} title=" تقييم العقار"/>
                  
                  
                  
                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 17) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 17)
                    ? <FaCheck/> : false} title=" الموافقة المبدئية"
                  />

                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 20) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 20)
                    ? <FaCheck/> : false} title=" السندات والعقود"
                  />


                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 19) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 19)
                   ? <FaCheck/> : false} title=" اصدار الشيكات"/>
                  <Step 
                  className={
                    orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 21) 
                  ? "step-complate" : ""} 
                  icon={ orderData?.FinancingRequestGeneralStatusLogs?.some(ele => ele?.FinancingRequestGeneralStatusId === 21)
                   ? <FaCheck/> : false} title=" الافراغ"/>
                </Steps>
                </div>
              </div>
            
            </div>

            <div className="client-details-action">
              <div className="time-details-holder">
                <div className="time-holder">
                  <p>وقت الإنشاء:</p>
                  <span>
                  {moment
                      .utc(orderData?.CreationDate)
                      .local()
                      .format("iYYYY/iM/iD - HH:MM")}
                  </span>
                </div>
                {orderData?.ModifiedDate && 
                <div className="time-holder">
                  <p>آخر تحديث:</p>
                  <span>
                  {moment
                      .utc(orderData?.ModifiedDate)
                      .local()
                      .format("iYYYY/iM/iD - HH:MM")}
                  </span>
                </div>
                }
              </div>
              {this.state.orderData?.FinancingRequestGeneralStatusLogs.some((ele) => ele.FinancingRequestGeneralStatusId === 8) &&
                  <Button type="primary" size="large" className="sky-btn sky-btn-header" 
                  onClick={()=>exportContractToPdf(orderData)}
                  >
                  <FaFileSignature />
                  عقد وساطة
                  </Button> 
                }
            </div>
          </div>
        </div>
        
        <div className="client-content">
          <div className="container">
            <div className="client-steps-wrapper">
              <Tabs activeKey={this.state.activeTab} tabPosition="left" className="client-tabs-wrapper" onChange={this.handelChangeTabs}>
        
              <TabPane
                  tab={
                    <span>
                      <FaUserAlt />
                      حالات الطلب
                    </span>
                  }
                  key="9"
                >
                  <ClientStatues loading={loading} orderId={orderId} StatusLogs={orderData?.FinancingRequestGeneralStatusLogs} />
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaUserAlt />
                      بيانات العميل
                    </span>
                  }
                  key="1"
                >
                  <ClientInfo loading={loading} userData={orderData?.Customer} />
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaFileInvoice />
                      بيانات الطلب
                    </span>
                  }
                  key="2"
                >
                  <ClientOrder userData={orderData}/>
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaBuilding />
                      بيانات التمويل
                    </span>
                  }
                  key="3"
                >
                  <ClientProperty userData={orderData}/>
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaMoneyCheck />
                      المديونيات
                    </span>
                  }
                  key="4"
                >
                  <Debtsdata orderId={orderId} />
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaFileInvoiceDollar />
                          الحسبه
                    </span>
                  }
                  key="5"
                >
                <Calculation orderId={orderId} userData={orderData}/>
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaFileAlt />
                          المستندات
                    </span>
                  }
                  key="6"
                >
                      <ClientDocs orderId={orderId}/>
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaFileAlt />
                      السندات والعقود
                    </span>
                  }
                  key="7"
                >
                    <ClientBonds userData={orderData} orderId={orderId}/>
                </TabPane>

                <TabPane
                  tab={
                    <span>
                      <FaFile />
                          الملاحظات
                      <Badge className="nots-badge" count={this.state.commentCount} />

                    </span>
                  }
                  key="8"
                >
                    <ClientNotes updateNotesBadge={this.updateNotesBadge}  orderId={orderId}/>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const ClientWithRouter = withRouter(Client);
const mapStateToProps = (state) => ({
  currentUser : state.user.currentUser,
  FinanceRequestStatuses : state.user.metaData.FinanceRequestStatuses,
  RequestDetails:state.order.RequestDetails
}) 
export default connect(mapStateToProps)(ClientWithRouter); 